import { defineStore } from "pinia";
import { PosthogManager } from "@core/managers/posthog.manager";

import {
  ACTION_BATCH_GET_ALL_NOTIFICATIONS,
  ACTION_BATCH_MARK_NOTIFICATION_AS_READ,
  ACTION_BATCH_GET_USER_DATA,
  GETTER_BATCH_GET_USER_DATA,
  ACTION_BATCH_SET_FETCHER,
  GETTER_BATCH_GET_FETCHER,
  GETTER_BATCH_GET_ALL_NOTIFICATIONS,
} from "../store/types";
import { PushNotifService } from "../services";
import { isIOS } from "../plugins/mobile";

const INBOX_MAX_PAGE_SIZE = 50;
const INBOX_LIMIT = 100;

export const useBatchStore = defineStore("batch", {
  // convert to a function
  state: () => ({
    batchUserData: {},
    // sometimes, functionalities of batch are called before batch initialization
    // so we initialize the fetcher to null in order to check if batch is initialized.
    inboxFetcher: null,
    notifications: [],
  }),
  getters: {
    [GETTER_BATCH_GET_USER_DATA]: (state) => state.batchUserData,
    [GETTER_BATCH_GET_FETCHER]: (state) => state.inboxFetcher,
    [GETTER_BATCH_GET_ALL_NOTIFICATIONS]: (state) => state.notifications,
  },
  actions: {
    async [ACTION_BATCH_SET_FETCHER](BatchManager) {
      const userIdentifier = this.batchUserData.data.custom_id;
      const authenticationKey = isIOS ? this.batchUserData.data.ios_token : this.batchUserData.data.android_token;
      const inboxFetcher = await BatchManager.batch.inbox.getFetcherForUser(userIdentifier, authenticationKey, INBOX_MAX_PAGE_SIZE, INBOX_LIMIT);
      this.inboxFetcher = inboxFetcher;
    },
    async [ACTION_BATCH_GET_ALL_NOTIFICATIONS]() {
      const { inboxFetcher } = this;
      try {
        const inboxResult = await inboxFetcher.fetchNewNotifications();
        const inboxAllResult = inboxResult.notifications;
        this.notifications = inboxAllResult;
      } catch (error) {
        PosthogManager.captureEvent("ErrorBatchGetNewNotification", error);
      }
    },
    async [ACTION_BATCH_GET_USER_DATA]({ operatingSystem, installationId, osVersion, env }) {
      const batchUserData = await PushNotifService.getCustomId({ operatingSystem, installationId, osVersion, env });
      this.batchUserData = batchUserData;
    },
    async [ACTION_BATCH_MARK_NOTIFICATION_AS_READ](notification) {
      const { inboxFetcher } = this;
      await inboxFetcher.markNotificationAsRead(notification);
    },
    // easily reset state using `$reset`
    clearBatchStore() {
      this.$reset();
    },
  },
});
